export default () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .rc-menu-submenu-title': {
      padding: 0
    }
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  }
});